import codepointsText from "assets/MaterialIcons-Regular.codepoints?raw";

export function parseMaterialIconsCodepoints(text) {
  return text
    .split("\n")
    .filter(Boolean)
    .map((line) => {
      const [name, hex] = line.split(" ");
      return [`0x${hex}`, name];
    });
}

export const MATERIAL_ICONS = parseMaterialIconsCodepoints(codepointsText);
